// Header-alias table for the CSV wizard's auto-suggest mapping.
// Kept in its own module so the alias set stays close to the (relatively
// stable) canonical lead-field vocabulary and the wizard component stays
// slim. The frontend intentionally maintains its own alias list rather than
// relying on the server: we want zero-latency mapping suggestions on upload.
export const CSV_HEADER_ALIASES = {
  firstname: "first_name", first_name: "first_name", first: "first_name",
  lastname: "last_name", last_name: "last_name", last: "last_name", surname: "last_name",
  phone: "phone", phone_number: "phone", mobile: "phone", cell: "phone",
  email: "email", email_address: "email",
  state: "state", st: "state",
  zip: "zip", zipcode: "zip", postal_code: "zip", postcode: "zip",
  city: "city", address: "address", street: "address", county: "county",
  accident_date: "accident_date", date_of_accident: "accident_date",
  lead_id: "external_lead_id", external_id: "external_lead_id",
  trustedform_url: "trustedform_url", trustedform: "trustedform_url",
  sub_1: "sub_1", sub1: "sub_1", sub_source: "sub_1", source: "sub_1",
  sub_2: "sub_2", sub2: "sub_2", sub_3: "sub_3", sub3: "sub_3",
  sub_4: "sub_4", sub4: "sub_4", sub_5: "sub_5", sub5: "sub_5",
  is_test: "is_test",
};

// Given the raw CSV headers + the server's canonical-field allowlist,
// return `{header: canonical}` for anything we can confidently auto-map.
export function suggestMapping(headers, canonicalFields) {
  const canon = new Set(canonicalFields);
  const out = {};
  headers.forEach((h) => {
    const k = h.toLowerCase().replace(/[^a-z0-9]/g, "_");
    const target = CSV_HEADER_ALIASES[k];
    if (target && canon.has(target)) out[h] = target;
  });
  return out;
}
